import { useLocation } from "react-router";
import { FoundersClubSignup, type Interest } from "../components/FoundersClubModal";

export function SignUpPage() {
  const { state } = useLocation();
  const initialInterest: unknown = (state as { initialInterest?: unknown } | null)?.initialInterest;
  const interest: Interest =
    initialInterest === "pro" || initialInterest === "dedicated" ? initialInterest : "lite";

  return (
    <div className="page">
      <FoundersClubSignup initialInterest={interest} />
    </div>
  );
}
